const { REACT_APP_AIRTABLE_API_KEY, REACT_APP_AIRTABLE_API_URL } = process.env;

export const editRequest = (id, approved) => {
	return fetch(REACT_APP_AIRTABLE_API_URL + '/PTO_Requests/' + id, {
		method: 'PATCH',
		headers: {
			'Authorization': 'Bearer ' + REACT_APP_AIRTABLE_API_KEY,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({
			fields: {
				"approved?": approved
			}
		})
	})
		.then(resp => resp.json())
		.then(json => json);
}


// WEBPACK FOOTER //
// ./src/utils/editRequests.js